import { useAdmin } from "../../../../context/admin";
import Modal from "../../../common/Modal";
import AdminService from "../../../../services/admin.service";
import { AiOutlineCloseCircle } from "react-icons/ai";

export default function ConfirmDeleteTour() {
    const { setConfirmDeleteTourId, confirmDeleteTourId } = useAdmin()
    async function deleteTour(id:string) {
        await AdminService.deleteTour(id)
        window.location.reload()
    }
    return (
        <Modal>
            <h1>Confirm delete tour</h1>
            <p>Are you sure you want to delete this tour? This action cannot be undone.</p>
            <p>This action will also delete reservations, trips, blogs, etc. Directly referenced to this tour among every agency</p>
            <div className="actions" style={{display: 'flex', gap: '10px', marginTop: '20px'}}>
                <button type="button" style={{backgroundColor: 'red', color: 'white', border: 'none'}}
                onClick={async () => {
                    await deleteTour(confirmDeleteTourId!)
                    window.location.reload()
                }}
                >Delete</button>
                <button type="button" style={{backgroundColor: 'gray', color: 'white', border: 'none'}}
                onClick={() => setConfirmDeleteTourId(undefined)}
                >Cancel</button>
            </div>
            <div className="close" title="close"
            onClick={() => setConfirmDeleteTourId(undefined)}
            >
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}